export default __webpack_public_path__ + "static/media/image.8e5917bf.png";